import { FinalisedQuestionnairesByType, SupplierEngagementGrid, QuestionnairesProgressByYear } from "./components";
import { Box, Flex, FormLabel, Select, useToast } from "@chakra-ui/react";
import { showErrorToast, sortAlphabeticallyByAttribute } from "../../../../../../../utils";
import { useState } from "react";
import { useGetAllSupplierCategories } from "../../../../../../../hooks/query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Card } from "../../../../../../../components/Card";

function SupplierEngagement() {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.suppliersData.supplierEngagement"
  });
  const toast = useToast();
  const [filterCategory, setFilterCategory] = useState("");

  const {
    data: categories,
    isFetching: isCategoriesFetching
  } = useGetAllSupplierCategories({
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  return (
    <Card boxShadow="xs">
      <Flex direction="column" gap={8}>
        <Box>
          <FormLabel
            htmlFor={"filterByCategorySelect"}
            opacity="0.75"
            fontSize="xs"
            whiteSpace="nowrap"
            blockSize="5"
            isTruncated
            color="esg_gray.200"
            marginBottom={0}
          >
            {t("filterBySupplierCategory")}
          </FormLabel>
          <Select
            id={"filterByCategorySelect"}
            placeholder={" "}
            backgroundColor="white"
            borderRadius="none"
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
            maxInlineSize={{ base: "full", lg: "xs" }}
          >
            {categories
              ?.sort((a, b) => sortAlphabeticallyByAttribute(a, b, "name"))
              ?.map(category => <option key={category?.id} value={category?.id}>{category?.name}</option>) ?? []
            }
          </Select>
        </Box>
        {!isCategoriesFetching && (
          <>
            <QuestionnairesProgressByYear categoryId={filterCategory} />
            <FinalisedQuestionnairesByType categoryId={filterCategory} />
            <SupplierEngagementGrid categoryId={filterCategory} />
          </>
        )}
      </Flex>
    </Card>
  );
}

export default SupplierEngagement;